/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_Wc1Inputs */

const en_wc_vs_who_wc1 = /** @type {(inputs: Wc_Vs_Who_Wc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`write essays, reports, letters, CVs or books and don't want to pay for a subscription`)
};

/**
* | output |
* | --- |
* | "write essays, reports, letters, CVs or books and don't want to pay for a subscription" |
*
* @param {Wc_Vs_Who_Wc1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_wc1 = /** @type {((inputs?: Wc_Vs_Who_Wc1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_Wc1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_wc1(inputs)
});
export { wc_vs_who_wc1 as "wc.vs.who_wc1" }